import styled from 'styled-components';

export const StyledSelectContainer = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
`;

export const StyledLabel = styled.label`
  ${({ children }) => !children && 'display: none;'}
  margin-right: 12px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
`;

export const StyledSelect = styled.select`
  min-width: 170px;
  background: ${({ theme }) => theme.COLORS.TRANSPARENT};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
  border-radius: 3px;
  padding: 11px 12px;
  appearance: none;
  cursor: pointer;
  font-weight: ${({ theme }) => theme.FONT_WEIGHTS.REGULAR};
`;

export const StyledCaret = styled.div`
  display: block;
  position: absolute;
  cursor: pointer;
  pointer-events: none;
  top: 50%;
  right: 1rem;
  border: solid ${({ theme }) => theme.COLORS.NEUTRAL_30};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: translateY(-50%) rotate(45deg);
`;
